import category from "./category.vue";

export default [
  {
    name: "admin-category",
    path: "/admin/category",
    component: category,
  },
];
